module.exports = __webpack_public_path__ + "img/DE02723.31a0682d.png";